// extracted by mini-css-extract-plugin
export default {"icon":"Tooltip-module__icon--JH84U"};